package fyi.moko.hotpl.ui.util

import kotlinx.datetime.Month
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

/**
 * Formats an epoch-millis timestamp as a short date, e.g. "Jun 20, 2026".
 * Uses kotlinx-datetime so it works on all platforms (Android, iOS/Native).
 */
fun formatDate(epochMillis: Long): String {
    val instant = Instant.fromEpochMilliseconds(epochMillis)
    val local = instant.toLocalDateTime(TimeZone.currentSystemDefault())
    val month = when (local.month) {
        Month.JANUARY -> "Jan"; Month.FEBRUARY -> "Feb"; Month.MARCH -> "Mar"; Month.APRIL -> "Apr"
        Month.MAY -> "May"; Month.JUNE -> "Jun"; Month.JULY -> "Jul"; Month.AUGUST -> "Aug"
        Month.SEPTEMBER -> "Sep"; Month.OCTOBER -> "Oct"; Month.NOVEMBER -> "Nov"; else -> "Dec"
    }
    return "$month ${local.day}, ${local.year}"
}
